import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  addMultipleReqDocuments,
  addReqDocuments,
  documentUploaded,
  getMultipleReqDocAddedStatus,
  getOtherLocalDocUploadSasUrl,
  getReqDocAddedStatus,
  getUploadDocumentId,
  multipleReqDocumentAdded,
  reqDocumentAdded,
  uploadDocument,
} from "../../store/documents";
import { getAlert, getConfirmAlert } from "../../../services/appAlerts";
import { getCurrentUser } from "../../store/auth";
import UploadRepository from "./UploadRepository";
import {
  ddrmsRepoReqDocUploaded,
  getDdrmsRepositoryDocuments,
  getDdrmsRepoUploadedDocId,
  loadDdrmsRepositoryDocs,
  UploadDdrmsReqRepositoryDocs,
} from "../../store/ddrmsDocument";
import PurchaseOrderPopup from "../../../ReviewTools/PurchaseOrderPopup";
import { uploadFileToBlob } from "../../../services/blobUploadService";
import { getSubsCurrentWfTask, loadSubcontractorWfTask, subsCurrentWfTaskReceived } from "../../store/subcontractor";
import { getRecCurrentWfTask, loadRecruiterWfTask, recCurrentWfTaskReceived } from "../../store/recruiter";
import { candidateCurrentWfTaskReceived, getCandidateCurrentWfTask, loadCandidateWfTask } from "../../store/candidate";

const UploadOther = (props) => {
  const {
    handleOtherDocShowHide,
    otherDocShowHide,
    workflowTask,
    onReqDocs,
    applicantObj,
    uploadType,
    viewType,
    prevItem,
    requiredDocument,
    embedded = false,
    bodyOnly = false,
    autoSubmit = false,
    deferSubmit = false,
    initialReferenceData = null,
    onStageReference = null,
    hideAddWithoutReference = false
  } = props;

  const [docName, setDocName] = useState("");
  const [docNotes, setDocNotes] = useState("");
  const [documents, setDocuments] = useState([]);
  const [btnProcess, setBtnProcess] = useState(null);
  const [selectedRepoDocs, setSelectedRepoDocs] = useState([]);
  const [refDocType, setRefDocType] = useState("local");
  const [isDragging, setIsDragging] = useState(false);
  const [selectedDocIds, setSelectedDocIds] = useState([]);
  const [selectedDocName, setSelectedDocName] = useState("");
  const [selectedKey, setSelectedKey] = useState("generate");
  const [poOrderType, setPoOrderType] = useState("add");
  const [wfTask, setWfTask] = useState(null);
  const [repoDocs, setRepoDocs] = useState([]);
  const [wfTaskReqCount, setWfTaskReqCount] = useState(0);
  const [repoLoading, setRepoLoading] = useState(false);
  const repositoryLoadStartedRef = useRef(false);
  const autoSubmitStartedRef = useRef(false);

  const getFileIconDetails = (fileName) => {
    const ext = fileName?.split(".").pop().toLowerCase();
    switch (ext) {
      case "pdf":
        return { icon: "fa fa-file-pdf-o", color: "#ef4444", bg: "#fef2f2", border: "#fee2e2" };
      case "docx":
      case "doc":
        return { icon: "fa fa-file-word-o", color: "#2563eb", bg: "#eff6ff", border: "#dbeafe" };
      case "xlsx":
      case "xls":
      case "csv":
        return { icon: "fa fa-file-excel-o", color: "#16a34a", bg: "#f0fdf4", border: "#dcfce7" };
      case "jpg":
      case "jpeg":
      case "png":
      case "gif":
      case "svg":
        return { icon: "fa fa-file-image-o", color: "#8b5cf6", bg: "#f5f3ff", border: "#ede9fe" };
      default:
        return { icon: "fa fa-file-o", color: "#64748b", bg: "#f8fafc", border: "#e2e8f0" };
    }
  };

  const reqDocAddedStatusSelector = useSelector(getReqDocAddedStatus);
  const multipleReqDocAddedStatusSelector = useSelector(
    getMultipleReqDocAddedStatus
  );
  const uploadDocumentIdSelector = useSelector(getUploadDocumentId);
  const ddrmsRepoUploadedDocIdSelector = useSelector(getDdrmsRepoUploadedDocId);
  const otherLocalDocUploadSasUrlSelector = useSelector(getOtherLocalDocUploadSasUrl);
  const ddrmsRepositoryDocumentsSelector = useSelector(getDdrmsRepositoryDocuments);

  const subsCurrentWfTaskSelector = useSelector(getSubsCurrentWfTask);
  const recCurrentWfTaskSelector = useSelector(getRecCurrentWfTask);
  const candidateCurrentWfTaskSelector = useSelector(getCandidateCurrentWfTask);

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (!otherDocShowHide) {
      setDocuments([]);
      setSelectedDocIds([]);
      setDocName("");
      setDocNotes("");
    }
  }, [otherDocShowHide]);

  useEffect(() => {
    if (otherDocShowHide && requiredDocument) {
      setSelectedDocIds([]);
      setSelectedDocName("");
      setDocName("");
      setDocNotes(requiredDocument.notes || "");
    }
  }, [otherDocShowHide, requiredDocument]);

  useEffect(() => {
    if (otherDocShowHide && initialReferenceData) {
      setRefDocType(initialReferenceData.refDocType || "local");
      setDocuments(initialReferenceData.documents || []);
      setSelectedRepoDocs(initialReferenceData.selectedRepoDocs || []);
      setDocNotes(initialReferenceData.docNotes || requiredDocument?.notes || "");
    }
  }, [otherDocShowHide, initialReferenceData, requiredDocument]);

  useEffect(() => {
    if (workflowTask?.ciid > 0) {
      if (refDocType === "ddrms") {
        repositoryLoadStartedRef.current = true;
        setRepoLoading(true);
        dispatch(loadDdrmsRepositoryDocs(workflowTask.ciid));
      }

      setWfTask(workflowTask);
    }
    else if (applicantObj?.id) {

      if (prevItem?.applications?.length > 0 && refDocType === "ddrms") {
        repositoryLoadStartedRef.current = true;
        setRepoLoading(true);
        dispatch(loadDdrmsRepositoryDocs(prevItem.applications[0].ciid));
      }


      if (uploadType === "Subcontractor") {
        let partnerUsrId = applicantObj?.id;
        if (viewType === "candidateList")
          partnerUsrId = applicantObj?.subcontractor?.parentid;
        if (partnerUsrId > 0) {
          dispatch(loadSubcontractorWfTask(partnerUsrId));
          setWfTaskReqCount(wfTaskReqCount + 1)
        }
      }

      if (uploadType === "Recruiter") {
        let partnerUsrId = applicantObj?.id;
        if (viewType === "candidateList")
          partnerUsrId = applicantObj?.recruiter?.parentid;
        if (partnerUsrId > 0) {
          dispatch(loadRecruiterWfTask(partnerUsrId));
          setWfTaskReqCount(wfTaskReqCount + 1)
        }
      }

      if (uploadType === "Candidate") {
        dispatch(loadCandidateWfTask(applicantObj?.id));
        setWfTaskReqCount(wfTaskReqCount + 1);
      }
    }
  }, [])

  useEffect(() => {
    if (subsCurrentWfTaskSelector && subsCurrentWfTaskSelector !== 0) {
      setWfTask(subsCurrentWfTaskSelector)
      setWfTaskReqCount(0);
    }
    else if (subsCurrentWfTaskSelector === 0 && !workflowTask && wfTaskReqCount <= 5) {
      let partnerUsrId = applicantObj?.id;
      if (viewType === "candidateList")
        partnerUsrId = applicantObj?.subcontractor?.parentid;
      if (partnerUsrId > 0) {
        setWfTaskReqCount(wfTaskReqCount + 1)
        dispatch(subsCurrentWfTaskReceived(null));
        setTimeout(() => {
          dispatch(loadSubcontractorWfTask(partnerUsrId));
        }, 1000);
      }
    }
  }, [subsCurrentWfTaskSelector]);

  useEffect(() => {
    if (recCurrentWfTaskSelector && recCurrentWfTaskSelector !== 0) {
      setWfTask(recCurrentWfTaskSelector)
      setWfTaskReqCount(0);
    } else if (recCurrentWfTaskSelector === 0 && !workflowTask && wfTaskReqCount <= 5) {
      let partnerUsrId = applicantObj?.id;
      if (viewType === "candidateList")
        partnerUsrId = applicantObj?.recruiter?.parentid;
      if (partnerUsrId > 0) {
        setWfTaskReqCount(wfTaskReqCount + 1)
        dispatch(recCurrentWfTaskReceived(null));
        setTimeout(() => {
          dispatch(loadRecruiterWfTask(partnerUsrId));
        }, 1000);
      }
    }
  }, [recCurrentWfTaskSelector]);

  useEffect(() => {
    if (candidateCurrentWfTaskSelector && candidateCurrentWfTaskSelector !== 0) {
      setWfTask(candidateCurrentWfTaskSelector)
      setWfTaskReqCount(0)
    } else if (candidateCurrentWfTaskSelector === 0 && !workflowTask && wfTaskReqCount <= 5) {
      setWfTaskReqCount(wfTaskReqCount + 1)
      dispatch(candidateCurrentWfTaskReceived(null));
      setTimeout(() => {
        dispatch(loadCandidateWfTask(applicantObj?.id));
      }, 1000);

    }
  }, [candidateCurrentWfTaskSelector]);

  useEffect(() => {
    if (refDocType === "ddrms" && wfTask?.ciid > 0) {
      repositoryLoadStartedRef.current = true;
      setRepoLoading(true);
      dispatch(loadDdrmsRepositoryDocs(wfTask.ciid));
    }
  }, [refDocType, wfTask])

  useEffect(() => {
    setRepoDocs(ddrmsRepositoryDocumentsSelector);
    if (repositoryLoadStartedRef.current) {
      setRepoLoading(false);
      repositoryLoadStartedRef.current = false;
    }
  }, [ddrmsRepositoryDocumentsSelector]);

  const handleSubmit = async (skipReference = false) => {
    if (deferSubmit && !autoSubmit) {
      if (onStageReference) {
        onStageReference({
          skipReference,
          refDocType,
          documents: [...documents],
          selectedRepoDocs: [...selectedRepoDocs],
          docNotes
        });
      }
      handleOtherDocShowHide("stage");
      return;
    }

    setBtnProcess(true);
    let task = { ...wfTask };
    task.performerId = parseInt(currentUser.id);
    let usrId = currentUser.id;
    if (viewType === "candidateList") {
      if (uploadType === "Recruiter" && applicantObj?.recruiter?.parentid)
        task.applicantId = applicantObj.recruiter.parentid;
      else if (
        uploadType === "Subcontractor" &&
        applicantObj?.subcontractor?.parentid
      )
        task.applicantId = applicantObj.subcontractor.parentid;
      else if (uploadType === "Candidate" && applicantObj?.id)
        task.applicantId = applicantObj?.id;
    } else if (applicantObj?.id) {
      task.applicantId = applicantObj?.id;
    }

    if (!skipReference && (documents.length > 0 || selectedRepoDocs.length > 0)) {
      let updType = "sharing";
      let isPwd = "";

      var frmData = new FormData();
      frmData.append("workflowTask", JSON.stringify(task));
      frmData.append("userId", currentUser.id);
      frmData.append("docType", "req");
      frmData.append("updType", updType);
      frmData.append("isPwd", isPwd);

      if (refDocType === "local") {
        // documents.map((file, key) =>
        //   frmData.append("files[" + key + "]", file.file)
        // );
        frmData.append("files", JSON.stringify(documents.map((file) => ({ name: file.name, type: file.type, size: file.size }))));
        if (autoSubmit) {
          dispatch(uploadDocument(frmData));
        } else {
          const result = await getConfirmAlert(
            "Warning",
            "Are you sure you want to send this Document?",
            "warning"
          );
          if (result.isConfirmed) dispatch(uploadDocument(frmData));
        }
      } else if (refDocType === "ddrms") {
        frmData.append("message", "Required Document");
        const updDocs = selectedRepoDocs.map((doc) => {
          const newDoc = { ...doc };
          newDoc.docType = "req";
          return newDoc;
        });
        frmData.append("doc", JSON.stringify(updDocs));
        if (autoSubmit) {
          dispatch(UploadDdrmsReqRepositoryDocs(frmData));
        } else {
          const result = await getConfirmAlert(
            "Warning",
            "Are you sure you want to send this Document?",
            "warning"
          );
          if (result.isConfirmed) dispatch(UploadDdrmsReqRepositoryDocs(frmData));
        }
      }
    } else {
      const allReqDocs = [];
      if (requiredDocument) {
        allReqDocs.push({
          formId: requiredDocument.id || requiredDocument.formId || 0,
          documnetName: requiredDocument.documnetName,
          notes: docNotes || requiredDocument.notes,
          ciid: requiredDocument.ciid || task.ciid,
          iiid: requiredDocument.iiid || task.iiid,
          wiid: requiredDocument.wiid || task.wiid,
          performerId: requiredDocument.performerId || (task.applicantId ? parseInt(task.applicantId) : null),
          addedBy: currentUser.id ? parseInt(currentUser.id) : 0,
          refDocId: requiredDocument.refDocId || null,
        });
      } else {
        selectedDocIds.forEach((id) => {
          const doc = onReqDocs.find((d) => d.id === id && d.name !== "Other");
          if (doc) {
            allReqDocs.push({
              formId: 0,
              documnetName: doc.name,
              notes: docNotes,
              ciid: task.ciid,
              iiid: task.iiid,
              wiid: task.wiid,
              performerId: task.applicantId ? parseInt(task.applicantId) : null,
              addedBy: currentUser.id ? parseInt(currentUser.id) : 0,
            });
          }
        });

        if (selectedDocName === "Other" && docName.trim() !== "") {
          allReqDocs.push({
            formId: 0,
            documnetName: docName,
            notes: docNotes,
            ciid: task.ciid,
            iiid: task.iiid,
            wiid: task.wiid,
            performerId: task.applicantId ? parseInt(task.applicantId) : null,
            addedBy: currentUser.id ? parseInt(currentUser.id) : 0,
          });
        }
      }

      if (allReqDocs.length > 0) dispatch(addMultipleReqDocuments(allReqDocs));
      //dispatch(addReqDocuments(frmObj));
    }
  };

  useEffect(() => {
    const skipReference = !initialReferenceData || initialReferenceData.skipReference === true;
    const initialReferenceType = initialReferenceData?.refDocType || "local";
    const referenceReady = skipReference || (
      refDocType === initialReferenceType &&
      (initialReferenceType === "local" ? documents.length > 0 : selectedRepoDocs.length > 0)
    );

    if (
      autoSubmit &&
      otherDocShowHide &&
      requiredDocument &&
      wfTask?.ciid > 0 &&
      referenceReady &&
      !autoSubmitStartedRef.current
    ) {
      autoSubmitStartedRef.current = true;
      handleSubmit(skipReference);
    }
  }, [autoSubmit, otherDocShowHide, requiredDocument, wfTask, initialReferenceData, refDocType, documents, selectedRepoDocs]);

  useEffect(() => {
    if (uploadDocumentIdSelector || ddrmsRepoUploadedDocIdSelector) {
      let task = { ...wfTask };
      task.performerId = parseInt(currentUser.id);
      let usrId = currentUser.id;
      if (viewType === "candidateList") {
        if (uploadType === "Recruiter" && applicantObj?.recruiter?.parentid)
          task.applicantId = applicantObj.recruiter.parentid;
        else if (
          uploadType === "Subcontractor" &&
          applicantObj?.subcontractor?.parentid
        )
          task.applicantId = applicantObj.subcontractor.parentid;
        else if (uploadType === "Candidate" && applicantObj?.id)
          task.applicantId = applicantObj?.id;
      } else if (applicantObj?.id) {
        task.applicantId = applicantObj?.id;
      }

      let refDocId = uploadDocumentIdSelector;

      if (refDocType === "ddrms" && ddrmsRepoUploadedDocIdSelector) {
        refDocId = ddrmsRepoUploadedDocIdSelector;
      }

      const allReqDocs = [];
      if (requiredDocument) {
        allReqDocs.push({
          formId: requiredDocument.id || requiredDocument.formId || 0,
          documnetName: requiredDocument.documnetName,
          notes: docNotes || requiredDocument.notes,
          ciid: requiredDocument.ciid || task.ciid,
          iiid: requiredDocument.iiid || task.iiid,
          wiid: requiredDocument.wiid || task.wiid,
          performerId: requiredDocument.performerId || (task.applicantId ? parseInt(task.applicantId) : null),
          addedBy: currentUser.id ? parseInt(currentUser.id) : 0,
          refDocId: refDocId,
        });
      } else {
        selectedDocIds.forEach((id) => {
          const doc = onReqDocs.find((d) => d.id === id && d.name !== "Other");
          if (doc) {
            allReqDocs.push({
              formId: 0,
              documnetName: doc.name,
              notes: docNotes,
              ciid: task.ciid,
              iiid: task.iiid,
              wiid: task.wiid,
              performerId: task.applicantId ? parseInt(task.applicantId) : null,
              addedBy: currentUser.id ? parseInt(currentUser.id) : 0,
              refDocId: refDocId,
            });
          }
        });

        if (selectedDocName === "Other" && docName.trim() !== "") {
          allReqDocs.push({
            formId: 0,
            documnetName: docName,
            notes: docNotes,
            ciid: task.ciid,
            iiid: task.iiid,
            wiid: task.wiid,
            performerId: task.applicantId ? parseInt(task.applicantId) : null,
            addedBy: currentUser.id ? parseInt(currentUser.id) : 0,
            refDocId: refDocId,
          });
        }
      }

      dispatch(addMultipleReqDocuments(allReqDocs));
      //dispatch(addReqDocuments(frmObj));
      //dispatch(documentUploaded(null));
      //dispatch(ddrmsRepoReqDocUploaded({status: null, docId: null}));
    }
  }, [uploadDocumentIdSelector, ddrmsRepoUploadedDocIdSelector]);

  useEffect(() => {
    if (otherLocalDocUploadSasUrlSelector && otherLocalDocUploadSasUrlSelector.length > 0) {
      documents.map((file, key) =>
        uploadFileToBlob(file, otherLocalDocUploadSasUrlSelector[key]?.uploadUrl, (progress) => {
          console.log(`Upload progress: ${progress}%`);
        })
      );
    }
  }, [otherLocalDocUploadSasUrlSelector]);

  useEffect(() => {
    if (reqDocAddedStatusSelector) {
      setBtnProcess(false);
      if (!autoSubmit) getAlert("", "Document Uploaded Successfully", "success");
      setDocName("");
      setDocNotes("");
      setDocuments([]);
      handleOtherDocShowHide("save");
      dispatch(documentUploaded(null));
      dispatch(ddrmsRepoReqDocUploaded({ status: null, docId: null }));
      dispatch(reqDocumentAdded(false));
    }
  }, [reqDocAddedStatusSelector]);

  useEffect(() => {
    if (multipleReqDocAddedStatusSelector) {
      setBtnProcess(false);
      if (!autoSubmit) getAlert("", "Document(s) Uploaded Successfully", "success");
      setDocName("");
      setDocNotes("");
      setDocuments([]);
      setSelectedDocIds([]);
      handleOtherDocShowHide("save");
      dispatch(documentUploaded(null));
      dispatch(ddrmsRepoReqDocUploaded({ status: null, docId: null }));
      dispatch(multipleReqDocumentAdded(false));
    }
  }, [multipleReqDocAddedStatusSelector]);

  const handleOnChange = (obj) => {
    console.log(obj);
  };

  const handleFileChange = (event) => {
    const docs = [...documents];
    for (const file of event.target.files) {
      var doc = {
        name: file.name,
        type: file.type,
        file: file,
        size: file.size,
      };
      docs.push(doc);
    }
    setDocuments(docs);

    event.target.value = null;
  };

  const handleFileRemove = (item) => {
    const updatedDocuments = documents.filter((doc) => doc !== item);
    setDocuments(updatedDocuments);
  };

  // Drag & Drop Handlers
  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = Array.from(e.dataTransfer.files);
    const docs = files.map((file) => ({
      name: file.name,
      type: file.type,
      size: (file.size / 1024).toFixed(2),
      file: file,
    }));
    setDocuments((prev) => [...prev, ...docs]);
  };

  const handleSelectedDocIds = (e) => {
    const { value, checked } = e.target;
    console.log(value, checked);
    if (checked) {
      setSelectedDocIds((prev) => [...prev, parseInt(value)]);
      const doc = onReqDocs.find(
        (d) => d.id === parseInt(value) && d.name === "Other"
      );
      if (doc) setSelectedDocName(doc.name);
    } else {
      setSelectedDocIds((prev) => prev.filter((id) => id !== parseInt(value)));
      const doc1 = onReqDocs.find(
        (d) => d.id === parseInt(value) && d.name === "Other"
      );
      if (doc1) setSelectedDocName("");
    }
  };

  const handleSelectedKey = (key) => {
    setSelectedKey(key);
  };

  const handlePurchaseShowHide = (item, type, poOrderType) => {
    // setSelectedDocId(0);
    // setSelectedDoc(null);
    // setPoOrderType(poOrderType);
    // setPurchaseShowHide(true);
    // if (item) {
    //     setSelectedItem(item);
    // }
  };
  const handleSignUnsignPo = (poOrder) => {
    // Logic to sign or unsign the purchase order
  };
  const handleRefreshPoOrders = () => {
    // Logic to refresh the purchase orders
    //handleModalShowHide("save");
    if (selectedKey !== "poOrder") handleOtherDocShowHide("save");
  };

  const Container = embedded ? "div" : Modal;

  const candidateName = applicantObj?.performername || applicantObj?.performerName || applicantObj?.label || applicantObj?.name || "";
  const candidateId = applicantObj?.performerid || applicantObj?.fuid || applicantObj?.id || "";
  const currentCiid = wfTask?.ciid || workflowTask?.ciid || "";

  return (
    <>
      <style>{`
        .modal-backdrop {
          z-index: 1080 !important;
        }
        .modal {
          z-index: 1090 !important;
        }
        .modal-backdrop.show {
          backdrop-filter: blur(8px) !important;
          -webkit-backdrop-filter: blur(8px) !important;
          background-color: rgba(15, 23, 42, 0.45) !important;
          opacity: 1 !important;
        }
        .modal.fade .uo-modal.modal-dialog {
          transform: scale(0.95) !important;
          transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
        }
        .modal.show .uo-modal.modal-dialog {
          transform: scale(1) !important;
        }
        .uo-modal {
          max-width: 92% !important;
          width: 1200px !important;
          margin: 1.5rem auto !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          color: #1e293b !important;
        }
        .uo-modal .modal-content {
          border-radius: 0 !important;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
          overflow: hidden !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          height: calc(100vh - 3rem) !important;
          max-height: calc(100vh - 3rem) !important;
          display: flex !important;
          flex-direction: column !important;
        }
        .uo-modal .modal-body {
          display: flex !important;
          flex-direction: column !important;
          flex: 1 1 auto !important;
          min-height: 0 !important;
          overflow: hidden !important;
          padding: 0 !important;
        }
        .uo-shell,
        .uo-shell button,
        .uo-shell input,
        .uo-shell select,
        .uo-shell textarea {
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
        }
        .uo-embedded,
        .uo-embedded .modal-body {
          width: 100% !important;
          max-width: 100% !important;
          padding: 0 !important;
          margin: 0 !important;
          box-sizing: border-box !important;
        }
        .uo-shell {
          background: #ffffff;
          display: flex !important;
          flex-direction: column !important;
          min-height: 0 !important;
          height: 100% !important;
          flex: 1 1 auto !important;
          overflow: hidden !important;
          width: 100% !important;
          max-width: 100% !important;
          box-sizing: border-box !important;
        }
        .uo-modal .modal-header {
          position: relative !important;
          display: block !important;
          padding: 14px 24px 12px 24px !important;
          background: #ffffff !important;
          border-bottom: 1px solid #edf2f7 !important;
          overflow: hidden !important;
          flex-shrink: 0 !important;
        }
        .uo-modal .modal-header::before {
          display: none !important;
        }
        .uo-modal .rt-header-shell {
          display: flex !important;
          flex-direction: column !important;
          gap: 10px !important;
          width: 100% !important;
        }
        .uo-modal .rt-header-top {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          gap: 16px !important;
          width: 100% !important;
        }
        .uo-modal .rt-header-main {
          display: flex !important;
          align-items: center !important;
          gap: 12px !important;
          min-width: 0 !important;
          flex: 1 1 auto !important;
        }
        .uo-modal .rt-header-icon {
          width: 40px !important;
          height: 40px !important;
          min-height: 40px !important;
          border-radius: 0 !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: #171717 !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
          font-size: 16px !important;
          flex-shrink: 0 !important;
        }
        .uo-modal .rt-header-copy {
          display: flex !important;
          flex-direction: column !important;
          gap: 4px !important;
          min-width: 0 !important;
        }
        .uo-modal .rt-modal-title {
          display: inline-flex !important;
          align-items: center !important;
          margin: 0 !important;
          color: #1e293b !important;
          font-size: 16.5px !important;
          font-weight: 600 !important;
          line-height: 1.2 !important;
        }
          font-weight: 500 !important;
          line-height: 1.2 !important;
        }
        .uo-modal .rt-modal-title-text {
          display: inline-flex !important;
          align-items: center !important;
          gap: 10px !important;
          flex-wrap: wrap !important;
        }
        .uo-modal .rt-modal-title-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 3px 8px !important;
          border-radius: 0 !important;
          font-size: 11px !important;
          font-weight: 600 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.04em !important;
          background: #171717 !important;
          color: #ffffff !important;
          border: 1px solid #171717 !important;
        }
        .uo-modal .rt-modal-meta-row {
          display: flex !important;
          align-items: center !important;
          flex-wrap: wrap !important;
          gap: 8px !important;
          font-size: 12px !important;
        }
        .uo-modal .rt-meta-chip {
          display: inline-flex !important;
          align-items: center !important;
          gap: 4px !important;
          background: #ffffff !important;
          padding: 3px 8px !important;
          height: 24px !important;
          min-height: 24px !important;
          box-sizing: border-box !important;
          border-radius: 0 !important;
          font-size: 11.5px !important;
          font-weight: 500 !important;
          color: #0f172a !important;
          border: 1px solid #cbd5e1 !important;
        }
        .uo-modal .rt-action-btn {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 38px !important;
          height: 38px !important;
          padding: 0 !important;
          font-size: 14px !important;
          color: #64748b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
          outline: none !important;
        }
        .uo-modal .rt-action-btn:hover {
          color: #1e293b !important;
          border-color: #94a3b8 !important;
          background: #f8fafc !important;
          transform: translateY(-1px) !important;
        }
        .uo-modal .rt-action-btn:hover i {
          color: #ef4444 !important;
        }
        .uo-body {
          padding: 14px 18px 18px;
          background: #ffffff;
          overflow: hidden !important;
          min-height: 0;
          height: 100%;
          display: flex;
          flex-direction: column;
          flex: 1 1 auto;
          width: 100% !important;
          max-width: 100% !important;
          box-sizing: border-box !important;
        }
        .uo-body-only .uo-body {
          padding: 0 !important;
        }
        .uo-panel {
          border: 1px solid #cbd5e1;
          border-radius: 0 !important;
          overflow: hidden !important;
          background: #ffffff;
          box-shadow: none !important;
          min-height: 0;
          height: 100%;
          display: flex;
          flex-direction: column;
          flex: 1 1 auto;
          width: 100% !important;
          max-width: 100% !important;
          box-sizing: border-box !important;
        }
        .uo-toolbar {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          padding: 10px 16px;
          background: #ffffff;
          border-bottom: 1px solid #e2e8f0;
          width: 100% !important;
          box-sizing: border-box !important;
          flex-shrink: 0;
        }
        .uo-section-label {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          margin: 0;
          color: #334155;
          font-size: 12px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.04em;
          text-align: left;
        }
        .uo-section-label i { color: #171717; }
        .uo-note { margin: 4px 0 0; color: #64748b; font-size: 12.5px; font-weight: 400; text-align: left; }
        .uo-content-scroll {
          padding: 14px 16px;
          overflow-y: auto !important;
          flex: 1 1 auto;
          min-height: 0;
          height: 100%;
          scrollbar-width: thin;
          scrollbar-color: #cbd5e1 transparent;
          width: 100% !important;
          max-width: 100% !important;
          box-sizing: border-box !important;
          display: flex;
          flex-direction: column;
        }
        .uo-content-scroll::-webkit-scrollbar { width: 6px; height: 6px; }
        .uo-content-scroll::-webkit-scrollbar-track { background: transparent; }
        .uo-content-scroll::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 0; }
        .uo-two-col {
          display: flex;
          gap: 14px;
          align-items: stretch;
          width: 100% !important;
          max-width: 100% !important;
          box-sizing: border-box !important;
          height: 100%;
          min-height: 0;
          flex: 1 1 auto;
        }
        .uo-left-panel {
          flex: 0 0 340px !important;
          width: 340px !important;
          min-width: 280px !important;
          max-width: 360px !important;
          display: flex;
          flex-direction: column;
          gap: 10px;
          background: #ffffff;
          border: 1px solid #cbd5e1;
          border-radius: 0 !important;
          padding: 12px;
          box-shadow: none !important;
          box-sizing: border-box !important;
          height: 100%;
          min-height: 0;
          overflow: hidden;
        }
        .uo-left-panel .uo-form-group {
          flex: 1 1 auto;
          display: flex;
          flex-direction: column;
          min-height: 0;
          height: 100%;
          overflow: hidden;
        }
        .uo-right-panel {
          flex: 1 1 0% !important;
          min-width: 0 !important;
          width: 100% !important;
          max-width: 100% !important;
          display: flex;
          flex-direction: column;
          gap: 14px;
          background: #ffffff;
          border: 1px solid #cbd5e1;
          border-radius: 0 !important;
          padding: 14px;
          box-shadow: none !important;
          box-sizing: border-box !important;
          overflow-y: auto;
          min-height: 0;
          height: 100%;
        }
        @media (max-width: 992px) {
          .uo-two-col { flex-direction: column; }
          .uo-left-panel,
          .uo-right-panel { width: 100% !important; max-width: 100% !important; flex: auto !important; }
        }
        .uo-form-group {
          display: flex;
          flex-direction: column;
          gap: 6px;
          text-align: left;
        }
        .uo-label {
          font-size: 12px !important;
          font-weight: 700 !important;
          color: #334155 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.04em !important;
          margin: 0 !important;
        }
        .uo-doc-card-list {
          display: flex;
          flex-direction: column;
          gap: 0;
          border: 1px solid #cbd5e1;
          border-radius: 0 !important;
          background: #ffffff;
          flex: 1 1 auto;
          min-height: 100px;
          height: 100%;
          max-height: 100%;
          overflow-y: auto;
          scrollbar-width: thin;
          scrollbar-color: #cbd5e1 transparent;
        }
        .uo-doc-card-row {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 10px 12px;
          border: 0;
          border-bottom: 1px solid #f1f5f9;
          border-radius: 0 !important;
          cursor: pointer;
          transition: all 0.15s ease;
          user-select: none;
          background: #ffffff;
          text-align: left;
        }
        .uo-doc-card-row:last-child {
          border-bottom: none;
        }
        .uo-doc-card-row:hover {
          background: #f8fafc;
        }
        .uo-doc-card-row:hover .uo-checkbox-custom {
          border-color: #2563eb;
        }
        .uo-doc-card-row.selected {
          background: #f0f9ff;
          box-shadow: inset 3px 0 0 0 #2563eb;
        }
        .uo-checkbox-wrap {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          position: relative;
          width: 18px;
          height: 18px;
          flex-shrink: 0;
        }
        .uo-checkbox-custom {
          width: 16px;
          height: 16px;
          border: 1.5px solid #cbd5e1;
          border-radius: 0 !important;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #ffffff;
        }
        .uo-checkbox-custom::after {
          content: "";
          display: none;
          width: 4px;
          height: 8px;
          border: solid white;
          border-width: 0 2px 2px 0;
          transform: rotate(45deg);
          margin-bottom: 2px;
        }
        .uo-doc-card-row.selected .uo-checkbox-custom {
          background-color: #2563eb;
          border-color: #2563eb;
        }
        .uo-doc-card-row.selected .uo-checkbox-custom::after {
          display: block;
        }
        .uo-doc-name {
          font-size: 13px;
          font-weight: 500;
          color: #1e293b;
          flex: 1;
        }
        .uo-doc-icon {
          font-size: 13px;
          color: #94a3b8;
          flex-shrink: 0;
        }
        .uo-doc-card-row.selected .uo-doc-icon {
          color: #2563eb;
        }
        .uo-choice-cards {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 12px;
          margin-top: 2px;
        }
        .uo-choice-card {
          border: 1px solid #cbd5e1;
          border-radius: 0 !important;
          background: #ffffff;
          padding: 10px 12px;
          cursor: pointer;
          transition: all 0.15s ease;
          display: flex;
          gap: 10px;
          align-items: center;
          text-align: left;
        }
        .uo-choice-card:hover {
          border-color: #94a3b8;
          background: #f8fafc;
        }
        .uo-choice-card.active {
          border-color: #171717;
          background: #f8fafc;
          box-shadow: inset 3px 0 0 0 #171717 !important;
        }
        .uo-choice-icon {
          width: 32px;
          height: 32px;
          border-radius: 0 !important;
          background: #ffffff;
          color: #171717;
          border: 1px solid #cbd5e1;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          flex-shrink: 0;
        }
        .uo-choice-card.active .uo-choice-icon {
          background: #171717;
          color: #ffffff;
          border-color: #171717;
        }
        .uo-choice-content {
          display: flex;
          flex-direction: column;
          gap: 2px;
          min-width: 0;
        }
        .uo-choice-title { font-size: 13px; font-weight: 600; color: #0f172a; }
        .uo-choice-desc { font-size: 11.5px; color: #64748b; line-height: 1.3; }

        .uo-input, .uo-textarea {
          width: 100%;
          min-height: 36px;
          padding: 6px 10px;
          border-radius: 0 !important;
          border: 1px solid #cbd5e1;
          background-color: #ffffff;
          color: #1e293b;
          font-size: 13px;
          font-weight: 400;
          transition: all 0.15s ease;
          outline: none;
        }
        .uo-input:focus, .uo-textarea:focus {
          border-color: #2563eb;
          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
        }
        .uo-drop-zone {
          border: 1.5px dashed #cbd5e1;
          border-radius: 0 !important;
          background: #f8fafc;
          padding: 16px 12px;
          text-align: center;
          cursor: pointer;
          transition: all 0.2s ease;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 6px;
        }
        .uo-drop-zone:hover {
          border-color: #94a3b8;
          background: #f1f5f9;
        }
        .uo-drop-zone.dragging {
          border-color: #2563eb;
          background: #eff6ff;
        }
        .uo-drop-icon {
          width: 34px;
          height: 34px;
          border-radius: 0 !important;
          background: #ffffff;
          border: 1px solid #cbd5e1;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          color: #171717;
          font-size: 14px;
        }
        .uo-drop-text { font-size: 13px; font-weight: 600; color: #0f172a; }
        .uo-drop-subtext { font-size: 12px; color: #64748b; }

        .uo-file-list {
          display: flex;
          flex-direction: column;
          gap: 8px;
          margin-top: 12px;
        }
        .uo-file-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 8px 12px;
          border: 1px solid #cbd5e1;
          border-radius: 0 !important;
          background: #ffffff;
          gap: 12px;
        }
        .uo-file-info {
          display: flex;
          align-items: center;
          gap: 8px;
          min-width: 0;
        }
        .uo-file-name {
          font-size: 13px;
          font-weight: 600;
          color: #1e293b;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .uo-file-size {
          font-size: 11px;
          font-weight: 500;
          background: #f1f5f9;
          color: #475569;
          padding: 2px 6px;
          border-radius: 0 !important;
          border: 1px solid #cbd5e1;
          white-space: nowrap;
        }
        .uo-file-remove {
          background: none;
          border: none;
          cursor: pointer;
          color: #64748b;
          transition: color 0.15s ease;
          padding: 4px;
          display: inline-flex;
        }
        .uo-file-remove:hover { color: #ef4444; }

        .uo-footer,
        .uo-modal .modal-footer {
          padding: 10px 20px !important;
          background: #f8fafc !important;
          border-top: 1px solid #edf2f7 !important;
          display: flex !important;
          align-items: center !important;
          justify-content: flex-end !important;
          gap: 10px !important;
          flex-shrink: 0 !important;
        }
        .uo-modal .wf-modal-footer-close-btn {
          display: inline-flex !important;
          align-items: center !important;
          gap: 7px !important;
          padding: 6px 14px !important;
          font-size: 13px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
          outline: none !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
        }
        .uo-modal .wf-modal-footer-close-btn:hover {
          background: #f8fafc !important;
          color: #1e293b !important;
          border-color: #94a3b8 !important;
          transform: translateY(-1px) !important;
        }
        .uo-modal .wf-modal-footer-close-btn:hover i {
          color: #ef4444 !important;
        }
        .uo-btn {
          min-height: 36px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          padding: 7px 16px;
          border-radius: 0 !important;
          font-size: 13.5px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.15s ease;
          white-space: nowrap;
          border: 1px solid #cbd5e1;
          background: #ffffff;
          color: #1e293b;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
        }
        .uo-btn:hover:not(:disabled) {
          background: #f8fafc;
          border-color: #94a3b8;
          transform: translateY(-1px);
        }
        .uo-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          box-shadow: none;
          transform: none;
        }
        .uo-btn.primary {
          background: #2563eb;
          border-color: #2563eb;
          color: #ffffff;
          box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2);
        }
        .uo-btn.primary:hover:not(:disabled) {
          background: #1d4ed8;
          border-color: #1d4ed8;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
        }
      `}</style>

      {embedded ? (
        <div className={`uo-embedded${bodyOnly ? " uo-body-only" : ""}`}>
          <div className="uo-shell">
            {!bodyOnly && (
              <div className="uo-header" style={{ padding: "20px 24px", borderBottom: "1px solid #edf2f7", background: "#ffffff" }}>
                <div className="rt-header-shell">
                  <div className="rt-header-top">
                    <div className="rt-header-main">
                      <i className="rt-header-icon fa fa-cloud-upload" aria-hidden="true" />
                      <div className="rt-header-copy">
                        <h2 className="rt-modal-title">
                          <span className="rt-modal-title-text">
                            <span>{requiredDocument ? "Upload Reference Document" : "Upload Other Documents"}</span>
                          </span>
                        </h2>
                        <div className="rt-modal-meta-row">
                          {uploadType && (
                            <span className="rt-meta-chip">
                              <i className="fa fa-briefcase" style={{ color: "#2563eb" }} />
                              <span>Performer: {uploadType}</span>
                            </span>
                          )}
                          {candidateName && (
                            <span className="rt-meta-chip">
                              <i className="fa fa-user" style={{ color: "#9333ea" }} />
                              <span>{candidateName}</span>
                            </span>
                          )}
                          {candidateId && (
                            <span className="rt-meta-chip">
                              <i className="fa fa-id-badge" style={{ color: "#6366f1" }} />
                              <span>ID: {candidateId}</span>
                            </span>
                          )}
                          {currentCiid && (
                            <span className="rt-meta-chip">
                              <i className="fa fa-hashtag" style={{ color: "#d97706" }} />
                              <span>CIID {currentCiid}</span>
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="uo-body">
              {selectedKey === "generate" && (
                <div className="uo-panel" role="tabpanel">
                  <div className="uo-toolbar">
                    <div>
                      <div className="uo-section-label">
                        <i className="fa fa-folder-open-o" /> Select & Upload Documents
                      </div>
                    </div>
                  </div>
                  <div className="uo-content-scroll">
                    <div className="uo-two-col">
                      <div className="uo-left-panel">
                        <div className="uo-form-group">
                          <label className="uo-label">Required Document Checklist</label>
                          <div className="uo-doc-card-list">
                            {requiredDocument ? (
                              <div className="uo-doc-card-row selected">
                                <span className="uo-checkbox-wrap">
                                  <span className="uo-checkbox-custom" />
                                </span>
                                <span className="uo-doc-name">{requiredDocument.documnetName}</span>
                                <span className="uo-doc-icon"><i className="fa fa-file-o" /></span>
                              </div>
                            ) : onReqDocs.map((doc) => {
                              const isSelected = selectedDocIds.includes(doc.id);
                              return (
                                <div
                                  key={doc.id}
                                  className={`uo-doc-card-row ${isSelected ? "selected" : ""}`}
                                  onClick={() => {
                                    const e = { target: { value: doc.id, checked: !isSelected } };
                                    handleSelectedDocIds(e);
                                  }}
                                >
                                  <span className="uo-checkbox-wrap">
                                    <span className="uo-checkbox-custom" />
                                  </span>
                                  <span className="uo-doc-name">{doc.name}</span>
                                  <span className="uo-doc-icon">
                                    <i className={doc.name === "Other" ? "fa fa-ellipsis-h" : "fa fa-file-o"} />
                                  </span>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>

                      <div className="uo-right-panel">
                        {selectedDocName === "Other" && (
                          <div className="uo-form-group">
                            <label htmlFor="uo-other-name" className="uo-label">Other Document Name</label>
                            <input
                              id="uo-other-name"
                              type="text"
                              className="uo-input"
                              placeholder="e.g. Candidate Passport Copy"
                              value={docName}
                              onChange={({ target }) => setDocName(target.value)}
                            />
                          </div>
                        )}

                        <div className="uo-form-group">
                          <label htmlFor="uo-doc-notes" className="uo-label">Document Notes / Description</label>
                          <textarea
                            id="uo-doc-notes"
                            rows={3}
                            className="uo-textarea"
                            placeholder="Add file notes, guidelines, or details context..."
                            value={docNotes}
                            onChange={({ target }) => setDocNotes(target.value)}
                          />
                        </div>

                        <div className="uo-form-group">
                          <label className="uo-label">Upload Reference Document Source</label>
                          <div className="uo-choice-cards">
                            <div
                              className={`uo-choice-card ${refDocType === "local" ? "active" : ""}`}
                              onClick={() => setRefDocType("local")}
                            >
                              <div className="uo-choice-icon">
                                <i className="fa fa-laptop" />
                              </div>
                              <div className="uo-choice-content">
                                <span className="uo-choice-title">Local files</span>
                                <span className="uo-choice-desc">Select local files</span>
                              </div>
                            </div>
                            <div
                              className={`uo-choice-card ${refDocType === "ddrms" ? "active" : ""}`}
                              onClick={() => setRefDocType("ddrms")}
                            >
                              <div className="uo-choice-icon">
                                <i className="fa fa-database" />
                              </div>
                              <div className="uo-choice-content">
                                <span className="uo-choice-title">DDRMS repo</span>
                                <span className="uo-choice-desc">Select repository files</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        {refDocType === "local" && (
                          <div className="uo-form-group" style={{ borderTop: "1px solid #f1f5f9", paddingTop: "16px" }}>
                            <label className="uo-label">Attachment Files</label>
                            <div
                              className={`uo-drop-zone ${isDragging ? "dragging" : ""}`}
                              onDragOver={handleDragOver}
                              onDragLeave={handleDragLeave}
                              onDrop={handleDrop}
                              onClick={() => fileInputRef.current.click()}
                            >
                              <div className="uo-drop-icon">
                                <i className="fa fa-cloud-upload" />
                              </div>
                              <span className="uo-drop-text">Drag & drop files here</span>
                              <span className="uo-drop-subtext">or click to browse from device</span>
                            </div>
                            <input
                              type="file"
                              multiple
                              ref={fileInputRef}
                              style={{ display: "none" }}
                              onChange={handleFileChange}
                            />

                            {documents.length > 0 && (
                              <div className="uo-file-list">
                                {documents.map((file, idx) => {
                                  const details = getFileIconDetails(file.name);
                                  return (
                                    <div key={idx} className="uo-file-row" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 14px", border: "1px solid #cbd5e1", borderRadius: "0", background: "#ffffff", gap: "12px" }}>
                                      <div className="uo-file-info" style={{ display: "flex", alignItems: "center", gap: "10px", minWidth: 0, flex: 1 }}>
                                        <div style={{ width: "30px", height: "30px", borderRadius: "0", display: "inline-flex", alignItems: "center", justifyContent: "center", background: "#f8fafc", border: "1px solid #cbd5e1", color: details.color, fontSize: "14px", flexShrink: 0 }}>
                                          <i className={details.icon} />
                                        </div>
                                        <span className="uo-file-name" title={file.name} style={{ fontSize: "13px", fontWeight: "600", color: "#1e293b", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{file.name}</span>
                                      </div>
                                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <span className="uo-file-size" style={{ fontSize: "11px", fontWeight: "500", background: "#f1f5f9", color: "#475569", padding: "2px 8px", borderRadius: "0", border: "1px solid #cbd5e1", whiteSpace: "nowrap" }}>{file.size} KB</span>
                                        <button
                                          type="button"
                                          className="uo-file-remove"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleFileRemove(file);
                                          }}
                                          style={{ background: "none", border: "none", cursor: "pointer", color: "#64748b", transition: "color 0.15s ease", padding: "4px", display: "inline-flex" }}
                                        >
                                          <i className="fa fa-times" />
                                        </button>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        )}

                        {refDocType === "ddrms" && (
                          <div className="uo-form-group" style={{ borderTop: "1px solid #f1f5f9", paddingTop: "16px" }}>
                            <label className="uo-label">Select DDRMS Repository Files</label>
                            <UploadRepository
                              repoDocs={repoDocs}
                              setSelectedRepoDocs={setSelectedRepoDocs}
                              loading={repoLoading}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {selectedKey === "poOrder" && viewType === "candidateList" && (
                <div className="uo-panel" role="tabpanel">
                  <div className="uo-toolbar">
                    <div>
                      <div className="uo-section-label">
                        <i className="fa fa-file-text-o" /> Purchase Order Workflow
                      </div>
                      <p className="uo-note">Configure, sign, and verify the purchase orders for recruitment processes.</p>
                    </div>
                  </div>
                  <div className="uo-content-scroll" style={{ padding: "0" }}>
                    <PurchaseOrderPopup
                      purchaseShowHide={true}
                      handlePurchaseShowHide={handlePurchaseShowHide}
                      candidateObj={applicantObj}
                      workflowTask={wfTask}
                      poOrderType={poOrderType}
                      item={{
                        partnerType:
                          uploadType === "Recruiter"
                            ? "Recruiter"
                            : "Sub-Contractors",
                      }}
                      handleSignUnsignPo={handleSignUnsignPo}
                      handleRefreshPoOrders={handleRefreshPoOrders}
                      renderType="generate"
                    />
                  </div>
                </div>
              )}
            </div>

            {!bodyOnly && (
              <div className="uo-footer">
                <button
                  type="button"
                  className="wf-modal-footer-close-btn"
                  onClick={handleOtherDocShowHide}
                >
                  <i className="fa fa-times" aria-hidden="true" /> Cancel
                </button>
                {selectedKey === "generate" && (
                  <>
                    {requiredDocument && !deferSubmit && !hideAddWithoutReference && (
                      <button
                        type="button"
                        className="uo-btn"
                        disabled={btnProcess}
                        onClick={() => handleSubmit(true)}
                      >
                        <i className="fa fa-plus-circle" /> Add Without Reference
                      </button>
                    )}
                    <button
                      type="button"
                      className="uo-btn primary"
                      disabled={
                        btnProcess ||
                        (requiredDocument
                          ? (refDocType === "local" ? documents.length === 0 : selectedRepoDocs.length === 0)
                          : selectedDocIds.length === 0)
                      }
                      onClick={() => handleSubmit(false)}
                    >
                      {btnProcess ? (
                        <i className="fa fa-circle-o-notch fa-spin" />
                      ) : (
                        <i className="fa fa-cloud-upload" />
                      )} {deferSubmit ? "Save Reference" : (requiredDocument ? "Attach Reference" : "Attach & Send")}
                    </button>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      ) : (
        <Modal
          show={Boolean(otherDocShowHide)}
          size="xl"
          centered
          onHide={handleOtherDocShowHide}
          dialogClassName="rt-tools-modal uo-modal"
          backdrop="static"
          keyboard={false}
        >
          {!bodyOnly && (
            <Modal.Header>
              <div className="rt-header-shell">
                <div className="rt-header-top">
                  <div className="rt-header-main">
                    <i className="rt-header-icon fa fa-cloud-upload" aria-hidden="true" />
                    <div className="rt-header-copy">
                      <h2 className="rt-modal-title">
                        <span className="rt-modal-title-text">
                          <span>{requiredDocument ? "Upload Reference Document" : "Upload Other Documents"}</span>
                        </span>
                      </h2>
                      <div className="rt-modal-meta-row">
                        {uploadType && (
                          <span className="rt-meta-chip">
                            <i className="fa fa-briefcase" style={{ color: "#2563eb" }} />
                            <span>Performer: {uploadType}</span>
                          </span>
                        )}
                        {candidateName && (
                          <span className="rt-meta-chip">
                            <i className="fa fa-user" style={{ color: "#9333ea" }} />
                            <span>{candidateName}</span>
                          </span>
                        )}
                        {candidateId && (
                          <span className="rt-meta-chip">
                            <i className="fa fa-id-badge" style={{ color: "#6366f1" }} />
                            <span>ID: {candidateId}</span>
                          </span>
                        )}
                        {currentCiid && (
                          <span className="rt-meta-chip">
                            <i className="fa fa-hashtag" style={{ color: "#d97706" }} />
                            <span>CIID {currentCiid}</span>
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="rt-action-btn"
                    onClick={handleOtherDocShowHide}
                    title="Close"
                  >
                    <i className="fa fa-times" aria-hidden="true" />
                  </button>
                </div>
              </div>
            </Modal.Header>
          )}

          <Modal.Body className="p-0">
            <div className="uo-shell">
              <div className="uo-body">
                {selectedKey === "generate" && (
                  <div className="uo-panel" role="tabpanel">
                    <div className="uo-toolbar">
                      <div>
                        <div className="uo-section-label">
                          <i className="fa fa-folder-open-o" /> Select & Upload Documents
                        </div>
                      </div>
                    </div>
                    <div className="uo-content-scroll">
                      <div className="uo-two-col">
                        <div className="uo-left-panel">
                          <div className="uo-form-group">
                            <label className="uo-label">Required Document Checklist</label>
                            <div className="uo-doc-card-list">
                              {requiredDocument ? (
                                <div className="uo-doc-card-row selected">
                                  <span className="uo-checkbox-wrap">
                                    <span className="uo-checkbox-custom" />
                                  </span>
                                  <span className="uo-doc-name">{requiredDocument.documnetName}</span>
                                  <span className="uo-doc-icon"><i className="fa fa-file-o" /></span>
                                </div>
                              ) : onReqDocs.map((doc) => {
                                const isSelected = selectedDocIds.includes(doc.id);
                                return (
                                  <div
                                    key={doc.id}
                                    className={`uo-doc-card-row ${isSelected ? "selected" : ""}`}
                                    onClick={() => {
                                      const e = { target: { value: doc.id, checked: !isSelected } };
                                      handleSelectedDocIds(e);
                                    }}
                                  >
                                    <span className="uo-checkbox-wrap">
                                      <span className="uo-checkbox-custom" />
                                    </span>
                                    <span className="uo-doc-name">{doc.name}</span>
                                    <span className="uo-doc-icon">
                                      <i className={doc.name === "Other" ? "fa fa-ellipsis-h" : "fa fa-file-o"} />
                                    </span>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>

                        <div className="uo-right-panel">
                          {selectedDocName === "Other" && (
                            <div className="uo-form-group">
                              <label htmlFor="uo-other-name" className="uo-label">Other Document Name</label>
                              <input
                                id="uo-other-name"
                                type="text"
                                className="uo-input"
                                placeholder="e.g. Candidate Passport Copy"
                                value={docName}
                                onChange={({ target }) => setDocName(target.value)}
                              />
                            </div>
                          )}

                          <div className="uo-form-group">
                            <label htmlFor="uo-doc-notes" className="uo-label">Document Notes / Description</label>
                            <textarea
                              id="uo-doc-notes"
                              rows={3}
                              className="uo-textarea"
                              placeholder="Add file notes, guidelines, or details context..."
                              value={docNotes}
                              onChange={({ target }) => setDocNotes(target.value)}
                            />
                          </div>

                          <div className="uo-form-group">
                            <label className="uo-label">Upload Reference Document Source</label>
                            <div className="uo-choice-cards">
                              <div
                                className={`uo-choice-card ${refDocType === "local" ? "active" : ""}`}
                                onClick={() => setRefDocType("local")}
                              >
                                <div className="uo-choice-icon">
                                  <i className="fa fa-laptop" />
                                </div>
                                <div className="uo-choice-content">
                                  <span className="uo-choice-title">Local files</span>
                                  <span className="uo-choice-desc">Select local files</span>
                                </div>
                              </div>
                              <div
                                className={`uo-choice-card ${refDocType === "ddrms" ? "active" : ""}`}
                                onClick={() => setRefDocType("ddrms")}
                              >
                                <div className="uo-choice-icon">
                                  <i className="fa fa-database" />
                                </div>
                                <div className="uo-choice-content">
                                  <span className="uo-choice-title">DDRMS repo</span>
                                  <span className="uo-choice-desc">Select repository files</span>
                                </div>
                              </div>
                            </div>
                          </div>

                          {refDocType === "local" && (
                            <div className="uo-form-group" style={{ borderTop: "1px solid #f1f5f9", paddingTop: "16px" }}>
                              <label className="uo-label">Attachment Files</label>
                              <div
                                className={`uo-drop-zone ${isDragging ? "dragging" : ""}`}
                                onDragOver={handleDragOver}
                                onDragLeave={handleDragLeave}
                                onDrop={handleDrop}
                                onClick={() => fileInputRef.current.click()}
                              >
                                <div className="uo-drop-icon">
                                  <i className="fa fa-cloud-upload" />
                                </div>
                                <span className="uo-drop-text">Drag & drop files here</span>
                                <span className="uo-drop-subtext">or click to browse from device</span>
                              </div>
                              <input
                                type="file"
                                multiple
                                ref={fileInputRef}
                                style={{ display: "none" }}
                                onChange={handleFileChange}
                              />

                              {documents.length > 0 && (
                                <div className="uo-file-list">
                                  {documents.map((file, idx) => {
                                    const details = getFileIconDetails(file.name);
                                    return (
                                      <div key={idx} className="uo-file-row" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 14px", border: "1px solid #cbd5e1", borderRadius: "0", background: "#ffffff", gap: "12px" }}>
                                        <div className="uo-file-info" style={{ display: "flex", alignItems: "center", gap: "10px", minWidth: 0, flex: 1 }}>
                                          <div style={{ width: "30px", height: "30px", borderRadius: "0", display: "inline-flex", alignItems: "center", justifyContent: "center", background: "#f8fafc", border: "1px solid #cbd5e1", color: details.color, fontSize: "14px", flexShrink: 0 }}>
                                            <i className={details.icon} />
                                          </div>
                                          <span className="uo-file-name" title={file.name} style={{ fontSize: "13px", fontWeight: "600", color: "#1e293b", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{file.name}</span>
                                        </div>
                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                          <span className="uo-file-size" style={{ fontSize: "11px", fontWeight: "500", background: "#f1f5f9", color: "#475569", padding: "2px 8px", borderRadius: "0", border: "1px solid #cbd5e1", whiteSpace: "nowrap" }}>{file.size} KB</span>
                                          <button
                                            type="button"
                                            className="uo-file-remove"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleFileRemove(file);
                                            }}
                                            style={{ background: "none", border: "none", cursor: "pointer", color: "#64748b", transition: "color 0.15s ease", padding: "4px", display: "inline-flex" }}
                                          >
                                            <i className="fa fa-times" />
                                          </button>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              )}
                            </div>
                          )}

                          {refDocType === "ddrms" && (
                            <div className="uo-form-group" style={{ borderTop: "1px solid #f1f5f9", paddingTop: "16px" }}>
                              <label className="uo-label">Select DDRMS Repository Files</label>
                              <UploadRepository
                                repoDocs={repoDocs}
                                setSelectedRepoDocs={setSelectedRepoDocs}
                                loading={repoLoading}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {selectedKey === "poOrder" && viewType === "candidateList" && (
                  <div className="uo-panel" role="tabpanel">
                    <div className="uo-toolbar">
                      <div>
                        <div className="uo-section-label">
                          <i className="fa fa-file-text-o" /> Purchase Order Workflow
                        </div>
                        <p className="uo-note">Configure, sign, and verify the purchase orders for recruitment processes.</p>
                      </div>
                    </div>
                    <div className="uo-content-scroll" style={{ padding: "0" }}>
                      <PurchaseOrderPopup
                        purchaseShowHide={true}
                        handlePurchaseShowHide={handlePurchaseShowHide}
                        candidateObj={applicantObj}
                        workflowTask={wfTask}
                        poOrderType={poOrderType}
                        item={{
                          partnerType:
                            uploadType === "Recruiter"
                              ? "Recruiter"
                              : "Sub-Contractors",
                        }}
                        handleSignUnsignPo={handleSignUnsignPo}
                        handleRefreshPoOrders={handleRefreshPoOrders}
                        renderType="generate"
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Modal.Body>

          {!bodyOnly && (
            <Modal.Footer className="uo-footer">
              <button
                type="button"
                className="wf-modal-footer-close-btn"
                onClick={handleOtherDocShowHide}
              >
                <i className="fa fa-times" aria-hidden="true" /> Cancel
              </button>
              {selectedKey === "generate" && (
                <>
                  {requiredDocument && !deferSubmit && !hideAddWithoutReference && (
                    <button
                      type="button"
                      className="uo-btn"
                      disabled={btnProcess}
                      onClick={() => handleSubmit(true)}
                    >
                      <i className="fa fa-plus-circle" /> Add Without Reference
                    </button>
                  )}
                  <button
                    type="button"
                    className="uo-btn primary"
                    disabled={
                      btnProcess ||
                      (requiredDocument
                        ? (refDocType === "local" ? documents.length === 0 : selectedRepoDocs.length === 0)
                        : selectedDocIds.length === 0)
                    }
                    onClick={() => handleSubmit(false)}
                  >
                    {btnProcess ? (
                      <i className="fa fa-circle-o-notch fa-spin" />
                    ) : (
                      <i className="fa fa-cloud-upload" />
                    )} {deferSubmit ? "Save Reference" : (requiredDocument ? "Attach Reference" : "Attach & Send")}
                  </button>
                </>
              )}
            </Modal.Footer>
          )}
        </Modal>
      )}
    </>
  );
};

export default UploadOther;
